// src/components/dashboard/RecentActivity.js
import React from 'react';
import { ShoppingCartIcon, GiftIcon, UserPlusIcon } from '@heroicons/react/24/outline';

const RecentActivity = () => {
    const activities = [
        { id: 1, type: 'purchase', customer: 'Alice Johnson', details: 'Earned 50 points', time: '5 mins ago', icon: ShoppingCartIcon, color: 'text-green-500' },
        { id: 2, type: 'redemption', customer: 'Bob Smith', details: 'Redeemed R100 discount', time: '1 hour ago', icon: GiftIcon, color: 'text-purple-500' },
        { id: 3, type: 'registration', customer: 'Charlie Brown', details: 'New member joined', time: '3 hours ago', icon: UserPlusIcon, color: 'text-blue-500' },
        { id: 4, type: 'purchase', customer: 'Diana Prince', details: 'Earned 120 points', time: 'Yesterday', icon: ShoppingCartIcon, color: 'text-green-500' },
        { id: 5, type: 'redemption', customer: 'Eve Adams', details: 'Redeemed free coffee', time: 'Yesterday', icon: GiftIcon, color: 'text-purple-500' },
        { id: 6, type: 'registration', customer: 'Frank White', details: 'New member joined', time: '2 days ago', icon: UserPlusIcon, color: 'text-blue-500' },
    ];

    return (
        <div className="bg-white rounded-lg shadow-md p-6 flex flex-col overflow-hidden">
            <h3 className="text-xl font-semibold text-gray-800 mb-7">Recent Activity</h3>
            <div className="flex-1 overflow-y-auto pr-2 -mr-2 max-h-80"> {/* Max height to ensure scrollability */}
                <ul className="space-y-4">
                    {activities.map((activity) => (
                        <li key={activity.id} className="flex items-center space-x-3 pb-2 border-b border-gray-100 last:border-b-0">
                            <activity.icon className={`h-6 w-6 ${activity.color}`} />
                            <div className="flex-1">
                                <p className="text-gray-800 font-medium">{activity.customer}</p>
                                <p className="text-sm text-gray-600">{activity.details}</p>
                            </div>
                            <span className="text-xs text-gray-500 flex-shrink-0">{activity.time}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default RecentActivity;